import React from 'react';
import { ShoppingBagIcon } from './icons';

interface ShopChipProps {
  label: string;
  onClick: () => void;
  /** Dark chip on video, light on stills. */
  video?: boolean;
  corner?: 'bottom-left' | 'top-left';
  /** A chip that only informs (an empty scene): dimmer, not clickable. */
  disabled?: boolean;
}

/** The "Shop this scene" pill that opens the item list. The label only, no item count next to it
 *  (Jason, SIL-1592: a shopper would not know what the number means). */
const ShopChip: React.FC<ShopChipProps> = ({ label, onClick, video = false, corner = 'top-left', disabled = false }) => (
  <div className={`shop-chip-lane ${corner === 'bottom-left' ? 'shop-chip-bottom' : 'shop-chip-top'}`}>
    <button
      data-silvr-ui="true"
      type="button"
      disabled={disabled}
      aria-disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        if (!disabled) onClick();
      }}
      className="shop-chip flex min-h-11 max-w-[calc(100%-1.5rem)] items-center gap-2 rounded-full px-4 py-2 text-sm font-medium shadow-lg backdrop-blur-md transition-colors"
      style={{ background: video ? (disabled ? 'rgba(3,7,18,.6)' : 'rgba(3,7,18,.82)') : 'rgba(255,255,255,.96)', color: video ? (disabled ? 'rgba(255,255,255,.8)' : 'white') : '#111827', cursor: disabled ? 'default' : 'pointer' }}
    >
      <ShoppingBagIcon /> {label}
    </button>
  </div>
);

export default ShopChip;
